import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=9a4972be&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4972be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a4972be')) {
      api.createRecord('9a4972be', component.options)
    } else {
      api.reload('9a4972be', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=9a4972be&scoped=true&", function () {
      api.rerender('9a4972be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2V86i30HdjsvT/JS/comp/Voucher-Unit.vue"
export default component.exports